export default {
  id: 105,
  title: 'Target #105 - Ryuk',
  url: 'https://cssbattle.dev/play/105',
  colors: ['#BAC7CE', '#475862', '#000000', '#868A64', '#5A6042', '#4E2B24'],
  solution:
    '<a a><a b><a c><a d><a e><style>[b],[d]{top:130;width:120;height:120;background:#000;border-radius:0 60px}[c],[e]{top:140;width:100;height:100;border-radius:9in;box-shadow:inset 0 15px #5a6042,inset 0 0 0 30px #868a64,inset 0 0 0 35px #000,inset 0 0 0 50px #4e2b24}body{background:#bac7ce}a{position:fixed}[a]{top:0;left:108;width:184;height:92;background:#475862;clip-path:polygon(0 0,100% 0,50% 100%)}[b]{left:30;transform:rotate(-15deg)}[c]{left:40}[d]{left:250;transform:rotate(105deg)}[e]{left:260}</style>',
}
